'use client'

import { useEffect, useRef, useState } from 'react'

interface InfoPopoverProps {
  tooltip: string
}

export const InfoPopover = ({ tooltip }: InfoPopoverProps) => {
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!open) return
    const handleClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClick)
    return () => document.removeEventListener('mousedown', handleClick)
  }, [open])

  return (
    <div ref={ref} className="relative inline-flex" style={{ zIndex: open ? 9999 : undefined }}>
      <button
        type="button"
        data-tracking="ignore"
        onClick={() => setOpen((v) => !v)}
        className="flex-shrink-0 cursor-pointer opacity-40 transition-opacity hover:opacity-70"
      >
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <g fill="#142546">
            <path d="M9.614 8.188a.614.614 0 0 0-1.227 0v4.909a.614.614 0 1 0 1.227 0z" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9 .21a8.795 8.795 0 1 0 0 17.592A8.795 8.795 0 0 0 9 .21M1.433 9.007a7.568 7.568 0 1 1 15.137 0 7.568 7.568 0 0 1-15.137 0"
            />
            <path d="M9.818 5.734a.818.818 0 1 1-1.636 0 .818.818 0 0 1 1.636 0" />
          </g>
        </svg>
      </button>
      {open && (
        <div className="absolute bottom-full left-1/2 z-[9999] mb-2" style={{ transform: 'translateX(-50%)' }}>
          <div className="min-w-[270px] max-w-[500px] rounded-lg bg-white px-4 py-3 text-sm leading-relaxed text-slate-600 shadow-lg ring-1 ring-slate-200">
            {tooltip}
          </div>
        </div>
      )}
    </div>
  )
}
